// extracted by mini-css-extract-plugin
export default {"SearchProducts--wrapper":"SearchComponent_SearchProducts--wrapper__WAXrR"};